'use strict';
var config = require('./slickConfig');

module.exports = {
    'diet-timings-carousel': function () {
        $('body').on('init:diet-timings-carousel', function() {
            $('.diet-timings-carousel').each(function() {
                if (!$(this).is(':visible') && $(this).hasClass('slick-slider')) {
                    $(this).slick('unslick');
                }
                $(this).on('init', function(e, slick){
                    if ($(e.target).find('.slick-dots li').length === 1) {
                        $(e.target).find('.slick-dots').addClass('d-none');
                    }
                });

                if ($(this).is(':visible') && !$(this).hasClass('slick-slider')) {
                    $(this).slick(config.dietTimimgs);
                }
            });
        });
        $('body').trigger('init:diet-timings-carousel');
    },

    'diet-paln-review-carousel': function () {
        $('.diet-paln-review-carousel').slick(config.dietReviews);
    },

    'diet-direct-nav': function () {
        var navParent = $('.diet-direct-nav .diet-direct-nav-item').parent();
        var activeSlide = $('.diet-direct-nav a.active').parent().index();
        $(navParent).slick(config.dietNav).slick('slickGoTo', activeSlide);
    }
};
